import React, { Component } from 'react';
import { isValidURL } from "../../../../utils/isValidUrl";
import prependProtocol from "../../../../utils/prependRequestProtocolToUrl";

export default class TableInput extends Component {

    constructor(props) {
        super(props);
        this.state = {
            inputSize: 'single',
            inputValue: props.defaultInputValue || '',
        };
    }

    handleInputChange = e => {
        const inputValue = e.target.value;
        if (inputValue.split('\n').length) {
            const getLineNumber = textarea =>
                textarea.value.substr(0, textarea.selectionStart).split('\n').length;
            const value = this.props.user && this.props.user.apikey ? inputValue : inputValue.split('\n').slice(0, 10).join('\n');
            this.setState({ inputValue: value });
            if (getLineNumber(this.tableTextarea) > 1) {
                this.setState({ inputSize: 'multiline' });
            } else {
                this.setState({ inputSize: 'single' });
            }
        }
    }

    handleSubmitButtonClick = async () => {
        const { inputValue } = this.state;
        let inputs = [...new Set(inputValue.split('\n'))];
        inputs = inputs.filter(line => line != "");
        inputs = inputs.map((item) => prependProtocol(item, ['https://', 'http://']))
        const urls = inputs.filter(input => isValidURL(input.trim()));
        const invalidUrls = inputs.filter(input => !isValidURL(input.trim()) && input);
        const apikey = this.props.user && this.props.user.apikey ? this.props.user.apikey : process.env.REACT_APP_API_KEY;
        this.props.handleInvalidUrls(invalidUrls);
        this.props.requestAPI(urls, apikey, this.props.user);
        if (inputValue) {
            this.setState({
                inputValue: '',
                inputSize: 'single',
            });
        }
    };

    render() {
        const tableInputClassName = 'table__input-wrap table__input-wrap_multiline';
        const buttonColor = this.props.isRequestPending ? "grey" : "green";
        return (
            <>
                {this.props.errorMessage ? <label style={{ color: "red" }}>
                    {this.props.errorMessage}
                </label> : ""}
                <div className={tableInputClassName}>
                    <textarea
                        placeholder="https://example.com"
                        wrap="hard"
                        spellCheck="false"
                        value={this.state.inputValue}
                        onChange={this.handleInputChange}
                        ref={el => (this.tableTextarea = el)}
                    />
                    <button className={"button button_accent-" + buttonColor} onClick={this.handleSubmitButtonClick}
                        disabled={this.props.isRequestPending}>
                        {this.props.data.length > 0 ? 'Add URLs' : 'Analyze URLs'}
                    </button>
                </div>
            </>
        );
    }
}
